import { defineMessages } from 'react-intl';

export default defineMessages({
  ACHIEVEMENT_UNLOCKED: {
    defaultMessage: 'Vous décrochez le badge : "<p>{achievementTitle}</p>"',
  },

  ACHIEVEMENT_UNLOCKED_DEFAULT: {
    defaultMessage: 'Découvrez-le sur votre page de progression',
  },
} as const);
